import { Component, Input, TemplateRef } from '@angular/core';

import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-main-footer',
  templateUrl: './main-footer.component.html',
  styleUrls: ['./main-footer.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class MainFooterComponent {
  @Input()
  templateRef: TemplateRef<any> = null;

  @Input()
  hideFooter = false;
}
